/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class GoalRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model(params) {
    let store = this.store;
    let person = this.session.person;
    return hash({
      person,
      goal: store.findRecord('goals/goal', params.goal_id),
      states: store.query('goals/state', {
        personId: person.id,
        goalId: params.goal_id,
        current: true,
      }),
      posts: store.query('posts/post', {
        personId: person.id,
        goalId: params.goal_id,
        include: 'reactions,comments',
      }),
    });
  }
}
